/* eslint-disable no-unused-vars */
import { createGlobalStyle } from 'styled-components';

import '../assets/styles/alert-default.css';
import '../assets/fonts/fonts.css'; // put it in a separate file for fix blinking (https://github.com/styled-components/styled-components/issues/2205)
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';

export default createGlobalStyle`
  html {
    height: 100%;
    font-family: 'HelveticaNeue', 'Helvetica Neue', 'Helvetica', 'SF Pro Text', 'Arial', sans-serif;
    color: ${p => p.theme.color.text};
    .app-wrapper{
      height: 100%;
    }
    a {
      text-decoration: none;
      outline: none;
      transition: opacity .25s ease-in-out;
      &:not(.no-opacity):hover {
        opacity: .7
      }
    }
    body {
      margin: 0;
      padding: 0;
      height: 100%;
      #app{
        height: 100%;
      }
      button {
        outline: none;
        border: 0;
        background: transparent;
      }
      /* style if open in webView */
      &.open-in-web-view {
        /* CSS specific to iOS devices */ 
        @supports (-webkit-overflow-scrolling: touch) {
          cursor: pointer; /* fix ios bug for click events */
        }
        /* hide apzzi */
        div[id^="appzi-launch-button"] {
          display: none !important;
        }
        .cc-window.cc-floating{
          display: none;
        }
        .show-only-web-view{
          display: block;
          &.inline{
            display: inline-block;
          }
        }
        .hide-only-web-view{
          display: none;
        }
        #g-recaptcha{
          display: none;
        }
      }
      .cc-window.cc-floating{
        z-index: 10;
        box-shadow: 0 0 5px 0 rgba(0,0,0,0.3);
      }
      .show-only-web-view{
        display: none;
      }
     
    }
    /* recaptch */
    .grecaptcha-badge{
        z-index: 1;
    }

    /* ──── Buttons ─────────────────────────────────────────────────────────────────────────── */
    button {
      font-family: 'HelveticaNeue', 'Helvetica Neue', 'Helvetica', 'SF Pro Text', 'Arial', sans-serif;
      font-size: 1.125rem;
      font-weight: 500;
      cursor: pointer;
      transition: opacity 0.25s ease-in-out;  /* blurred fonts */
      &.btn-primary {
        padding: 7px;
        height: 48px;
        border-radius: 6px;
        background-color: ${(p) => p.theme.color.primary};
        color: ${(p) => p.theme.color.white};
        &:disabled {
          background-color: ${(p) => p.theme.color.disabled};
        }
      }
      &.btn-border-only {
        padding: 7px;
        height: 48px;
        border-radius: 6px;
        color: ${(p) => p.theme.color.primary};
        border: solid 2px ${(p) => p.theme.color.primary};
        &:disabled {
          color: ${(p) => p.theme.color.disabled};
          border: solid 2px ${(p) => p.theme.color.disabled};
        }
      }
      &.btn-like-link {
        display: inline-block;
        padding: 0;
        width: initial;
        font-size: 1em;
        height: initial;
        color: ${(p) => p.theme.color.primary};
        border: none;
        &:disabled {
          color: ${(p) => p.theme.color.label};
        }
      }
      &:hover {
        opacity: .8;        
      }
      &:disabled {
        pointer-events: none;
      }    
    }

    /* ──── Table rows color ────────────────────────────────────────────────────────────────── */
    tr {
      /* booked */
      &.booked {
        color: ${p => p.theme.color.text};
      }
      /* arrived */
      &.arrived {
        background-color: ${p => p.theme.color.veryLightBlue};
        .time-line {
          background-color: #6aa6eb;
        }
      }
      /* in-progress */
      &.in-progress {
        background-color: ${p => p.theme.color.veryLightRed};
        .time-line {
          background-color: #ef5350;
        }
      }
      /* to-radiology */
      &.to-radiology {
        background-color: ${p => p.theme.color.veryLightPurple};
        .time-line {
          background-color: ${p => p.theme.color.purple};
        }
      }
      /* from-radiology */
      &.from-radiology {
        background-color: ${p => p.theme.color.veryLightBlue};
        .time-line {
          background-color: #6aa6eb;
        }
      }
      /* restart-consultation */
      &.restart-consultation {
        background-color: ${p => p.theme.color.veryLightGold};
        .time-line {
          background-color: ${p => p.theme.color.gold};
        }
      }
      /* finished */
      &.finished {
        background-color: ${p => p.theme.color.veryLightGreen};
        .time-line {
          background-color: #3accac;
        }
      }
      /* paid */
      &.paid {
        color: ${p => p.theme.color.label};       
        .time-line {
          background-color: #e9eaed;
        }
      }
      /* canceled */
      &.cancelled {
        color: ${p => p.theme.color.error};
      }
    }
  }
`;
